import * as React from 'react';
import { connect } from 'react-redux';
import { warningInsideBubble, warningHref } from '../WarningContent/WarningInsideBubble';

/* Helpers */
const mapStateToProps = ({ api: { s3BasePath } }) => ({
  s3BasePath
});

export const style = {
  width: '25px',
  height: '25px'
};

/* Components */
const DisplayerIcon: React.FunctionComponent<{ s3BasePath: string }> = ({ s3BasePath }) => (
  <img
    alt={`${warningInsideBubble} For more information go to ${warningHref}.`}
    src={`${s3BasePath}mkt/icon/info_icon_white.png`}
    style={style}
  />
);

export default connect(mapStateToProps)(DisplayerIcon);
